<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">Special Offers Archive</p>
    </header>

    <section class="modal-card-body" >
        <main class="grid">
          <div v-for="(im,id1) in libImages" :key="id1">
            <img :src="im.url" style="cursor:pointer" @click="isImageModalActive=true; selectedImage=im.url" alt="">
            <b-modal :active.sync="isImageModalActive" scroll="keep">
                <p class="image">
                    <img :src="selectedImage" >
                </p>
            </b-modal>
            <span class="caption">
            <table>
    <td>{{im.name}}</td>
    <td style="color:#3e8ed0">{{formatBytes(im.size, 2)}}</td>
    <td><b-button :disabled="role === 'viewer'" style="height:20px" icon-left="trash" class="button is-danger is-small" @click="deleteResource(im.name)"></b-button></td>
            </table>
            </span>
          </div>
        </main>
     </section>

    <footer class="modal-card-foot">
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
      <b-button :disabled="role === 'viewer'" type="is-info" @click="submitChanges()">Submit</b-button>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'OffersArchive',
  data: () => {
    return {
      libImages: [],
      loadingComponent: null,
      isImageModalActive: false,
      selectedImage: String,
      filesToDelete: [],
      initialCount: 0,
      deleteCount: 0,
      removedCount: 0
    }
  },
  computed: {
    role () {
      return this.$store.state.role
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    var menuDirsRef = null
    if (!this.getNotMigrated().includes(this.$store.state.uid)) {
      menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffersArchive/')
    } else {
      menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffersArchive/')
    }
    menuDirsRef.listAll().then((dir) => {
      dir.items.forEach(fileRef => {
        this.initialCount++
        fileRef.getDownloadURL().then((url) => {
          const xhr = new XMLHttpRequest()
          xhr.responseType = 'blob'
          xhr.onload = (event) => {
            const blob = xhr.response
            var file = new File([blob], fileRef.name, {type: blob.type})
            this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
            this.loadingComponent.close()
          }
          xhr.open('GET', url)
          xhr.send()
        }).catch((error) => {
          this.globalLogger('error', error)
        })
      })
    })
  },
  methods: {
    deleteResource (fileN) {
      this.$buefy.dialog.confirm({
        message: 'Do you want to delete resource "' + fileN + '")?',
        cancelText: 'No',
        confirmText: 'Yes',
        type: 'is-danger',
        onConfirm: () => {
          this.libImages = this.libImages.filter(x => x.name !== fileN)
          this.deleteCount++
          this.filesToDelete.push(fileN)
          this.$buefy.toast.open({
            duration: 3000,
            message: 'The resource will be deleted on submit.'
          })
        }
      })
    },
    submitChanges () {
      let deletePromiseList = []
      this.loadingComponent = this.$buefy.loading.open()
      let removeMenuFilesRef = null
      if (!this.getNotMigrated().includes(this.$store.state.uid)) {
        removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffersArchive/')
      } else {
        removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffersArchive/')
      }
      if (this.role !== 'viewer') {
        removeMenuFilesRef.listAll().then(dir => {
          dir.items.forEach(fileRef => {
            if (this.filesToDelete.includes(fileRef.name)) {
              this.globalLogger('removing file ', fileRef.name)
              deletePromiseList.push(fileRef.delete())
              this.removedCount++
            }
          })
        }).finally(() => {
          Promise.all(deletePromiseList).then(() => {
            this.globalLogger('then')
            if (this.$store.state.specialOffersArchive.items !== null) {
              this.globalLogger('files to Delete: ', this.filesToDelete)
              var archItems = this.$store.state.specialOffersArchive.items
              this.globalLogger('archItems before: ', archItems)
              for (let i = 0; i < this.filesToDelete.length; i++) {
                archItems = archItems.filter(c => c.resName !== this.filesToDelete[i])
              }
              this.globalLogger('archItems after: ', archItems)
              if (!this.getNotMigrated().includes(this.$store.state.uid)) {
                this.$store.state.database.ref('/neoslide/archive/' + this.$store.state.workspaceId + '/specialOffers/').update({
                  items: archItems
                })
              } else {
                this.$store.state.database.ref('/archive/' + this.$store.state.uid + '/specialOffers/').update({
                  items: archItems
                })
              }
            }
            this.$parent.close()
            this.loadingComponent.close()
          })
        })
      } else {
        this.$parent.close()
        this.loadingComponent.close()
      }
    },
    formatBytes (bytes, decimals) {
      if (bytes === 0) {
        return '0 B'
      }
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    closeModal () {
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap:20px;
  align-items: center;
  }
.grid img {
  box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
  max-width: 100%;
}
.active {
  border: 3.2px solid #3e8ed0;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
td, th {
  padding: 4px;
  font-size: 12px;
  max-width: 100px;
  word-break: break-all;
}
table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/storage/offers/OffersArchive.vue